import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { observer } from 'mobx-react-lite'

import { PresenceAvatars } from 'common/PresenceAvatars/PresenceAvatars'
import { RootState, UsersMetadata } from 'types'
import { DocPresenceContext } from 'stores/DocPresence'
import { useAuthOrUnregisteredUser } from 'hooks/useAuthOrUnregisteredUser'

import { excludeUserFromPresentUsers } from 'utils/excludeUserFromPresentUsers'

interface Props {
  articleId: string
  className?: string
}

export const DocPresenceAvatars = observer(({ articleId, className }: Props) => {
  const docPresence = useContext(DocPresenceContext)
  const { user } = useAuthOrUnregisteredUser()

  const metadata = useSelector(({ colors }: RootState) => {
    if (colors[articleId]) {
      const result: UsersMetadata = {}

      Object.keys(colors[articleId]).forEach((userId: string) => {
        result[userId] = { color: colors[articleId][userId] }

        const cursor = document.querySelector(`[data-presence-cursor="true"][data-user-id="${userId}"]`)

        if (cursor) {
          result[userId] = {
            ...result[userId],
            present: true,
            onClick: (event) => {
              event.preventDefault()
              cursor.scrollIntoView({ block: 'center', behavior: 'smooth' })
            },
          }
        }
      })

      return result
    }
    return {}
  })

  if (!docPresence) {
    return null
  }

  const presentUsers = excludeUserFromPresentUsers(user, docPresence.usersOnDoc)

  return (
    <PresenceAvatars
      className={className}
      users={presentUsers}
      metadata={metadata}
      showMinCount={1}
      showMaxCount={3}
      docPresence={docPresence}
    />
  )
})
